import React from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { FormCard } from 'components/Card';
import { ErrorMessage } from 'components/Message';

export const Page: React.FC = observer(() =>
{
  const { uiStore } = useStore();
  const history = useHistory();
  const navigate = (path: string) => history.push(path);
  const pageLabels = uiStore.labels.pages.accessDenied;

  return (
    <article className="page access-denied">
      <FormCard>
        <h1>{pageLabels.title}</h1>
        <ErrorMessage>{pageLabels.explanationLines.map((x, i) => <React.Fragment key={i}>{x}<br/></React.Fragment>)}</ErrorMessage>
        <div className="actions">
          <button onClick={() => navigate(paths.buildDashboardPath())}>{pageLabels.toDashboard}</button>
        </div>
      </FormCard>
    </article>
  );
});
